import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import {
  Container,
  Header,
  IconWrapper,
  StyledShapeIcon,
  TextContainer,
} from "./setup-list.styles";
import SetupImage from "../../../../assets/setup-item-header.png";

export interface SetupListRootProps {
  title: string;
  description: string;
  illustrationUrl?: string;
  children?: React.ReactNode;
}

export const SetupListRoot = ({
  title,
  description,
  children,
}: SetupListRootProps) => {
  return (
    <Container>
      <Header>
        <IconWrapper isFirst>
          <StyledShapeIcon
            name="IconPlayerPlay"
            size={24}
            variant="default"
            color="var(--color-secondary-50)"
          />
        </IconWrapper>
        <TextContainer>
          <Typography variant="headline9" color="neutral.20">
            {title}
          </Typography>
          <Typography variant="body4" color="neutral.40">
            {description}
          </Typography>
        </TextContainer>
        <div style={{ maxWidth: 200 }}>
          <img src={SetupImage} alt="setup header" />
        </div>
      </Header>
      {children}
    </Container>
  );
};
